import { SurveyItem } from './types/onboardingTypes';

/**
 * List of questions for the privacy survey
 */
export const privacySurvey: { [key: string]: SurveyItem } = {
  CPP_CERT2_7: {
    text: '1.7: Does the application receive, store, transmit or process any Personal Information as defined by the Information Classification Policy?',
  },
  CPP_CERT2_8: {
    text: '1.8: Does the system persist PI data, as defined by CPP, in any form (logs, files, cache, database, etc.) longer than 48 hours? This question is not related to the frequency of refresh from the source system, but rather when the data was originally created. For example, if you refresh 5-years of call data daily, you have 5-years worth of call data (not 24-hours which is less than 48-hours), therefore you would answer YES to this question.',
  },
  CPP_CERT2_9: {
    text: '1.9: Does the application persist any unique data?',
  },
  CPP_CERT2_10: {
    text: '1.10: Are any of PI Attributes in the application required for operational integrity or providing service to Comcast Customers?',
  },
  CPP_CERT2_11: {
    text: '1.11: Does the application persist any workforce member (employee, contractor, etc.) data?',
  },
  CPP_CERT2_12: {
    text: '1.12: Does the application persist unstructured data (e.g., customer service call notes)?',
  },
  CPP_CERT2_13: {
    text: '1.13: Are there any technical limitations that may prevent the application from integrating with the Request Broker?',
  },
};
